module.exports = __webpack_public_path__ + "static/img/title.4d6daac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LayoutHTML/mocker/title.svg
// module id = 475
// module chunks = 0